"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.10
//   protoc               v6.33.5
// source: protos/money.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.BinData = exports.PaymentRestriction = exports.CostcoOwner = exports.IncentiveModel = exports.DiscountedSession = exports.FreeChargingSession = exports.MembershipPricing_TierPricingModelsEntry = exports.MembershipPricing = exports.PricingModel = exports.IdleFees = exports.Freemode = exports.PricePerMinute = exports.PricePerMinuteTier = exports.PricePerKWH = exports.ChargeBreakdown_TimeBasedCharge = exports.ChargeBreakdown_SurchargeBreakdown = exports.ChargeBreakdown = exports.Surcharge = exports.Money = exports.cardNetworkToJSON = exports.cardNetworkFromJSON = exports.CardNetwork = exports.cardPaymentErrorToJSON = exports.cardPaymentErrorFromJSON = exports.CardPaymentError = exports.surchargeTypeToJSON = exports.surchargeTypeFromJSON = exports.SurchargeType = exports.freeReasonToJSON = exports.freeReasonFromJSON = exports.FreeReason = exports.membershipAuthorizationTypeToJSON = exports.membershipAuthorizationTypeFromJSON = exports.MembershipAuthorizationType = exports.membershipAuthorizationModeToJSON = exports.membershipAuthorizationModeFromJSON = exports.MembershipAuthorizationMode = exports.paymentAuthorizationStatusToJSON = exports.paymentAuthorizationStatusFromJSON = exports.PaymentAuthorizationStatus = exports.paymentAuthorizationTypeToJSON = exports.paymentAuthorizationTypeFromJSON = exports.PaymentAuthorizationType = exports.protobufPackage = void 0;
/* eslint-disable */
const wire_1 = require("@bufbuild/protobuf/wire");
const timestamp_1 = require("../google/protobuf/timestamp");
exports.protobufPackage = "money";
/** The type of payment authorization for a given transaction. */
var PaymentAuthorizationType;
(function (PaymentAuthorizationType) {
    PaymentAuthorizationType[PaymentAuthorizationType["AUTHORIZATION_TYPE_UNKNOWN"] = 0] = "AUTHORIZATION_TYPE_UNKNOWN";
    PaymentAuthorizationType[PaymentAuthorizationType["AUTHORIZATION_TYPE_CARD_PRESENT"] = 1] = "AUTHORIZATION_TYPE_CARD_PRESENT";
    PaymentAuthorizationType[PaymentAuthorizationType["AUTHORIZATION_TYPE_CARD_PRESENT_OFFLINE"] = 2] = "AUTHORIZATION_TYPE_CARD_PRESENT_OFFLINE";
    PaymentAuthorizationType[PaymentAuthorizationType["AUTHORIZATION_TYPE_CARD_PRESENT_PHONE"] = 3] = "AUTHORIZATION_TYPE_CARD_PRESENT_PHONE";
    PaymentAuthorizationType[PaymentAuthorizationType["AUTHORIZATION_TYPE_REMOTE_AUTHORIZED_COMMAND_CONSOLE"] = 4] = "AUTHORIZATION_TYPE_REMOTE_AUTHORIZED_COMMAND_CONSOLE";
    PaymentAuthorizationType[PaymentAuthorizationType["AUTHORIZATION_TYPE_REMOTE_AUTHORIZED_OCPI"] = 5] = "AUTHORIZATION_TYPE_REMOTE_AUTHORIZED_OCPI";
    /** RESERVED - Old noc agent free status. Not used anymore, left to allow for old powernode software. */
    PaymentAuthorizationType[PaymentAuthorizationType["RESERVED"] = 6] = "RESERVED";
    PaymentAuthorizationType[PaymentAuthorizationType["AUTHORIZATION_TYPE_RFID_AUTHORIZED_OCPI"] = 7] = "AUTHORIZATION_TYPE_RFID_AUTHORIZED_OCPI";
    PaymentAuthorizationType[PaymentAuthorizationType["AUTHORIZATION_TYPE_REMOTE_AUTHORIZED_OCPP"] = 8] = "AUTHORIZATION_TYPE_REMOTE_AUTHORIZED_OCPP";
    /**
     * AUTHORIZATION_TYPE_RFID_AUTHORIZED_OCPP - An RFID tap authorized over the charger's OCPP connection (live Authorize, or the cached
     * local authorization list), as opposed to the OCPI cloud path above.
     */
    PaymentAuthorizationType[PaymentAuthorizationType["AUTHORIZATION_TYPE_RFID_AUTHORIZED_OCPP"] = 9] = "AUTHORIZATION_TYPE_RFID_AUTHORIZED_OCPP";
    PaymentAuthorizationType[PaymentAuthorizationType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(PaymentAuthorizationType = exports.PaymentAuthorizationType || (exports.PaymentAuthorizationType = {}));
function paymentAuthorizationTypeFromJSON(object) {
    switch (object) {
        case 0:
        case "AUTHORIZATION_TYPE_UNKNOWN":
            return PaymentAuthorizationType.AUTHORIZATION_TYPE_UNKNOWN;
        case 1:
        case "AUTHORIZATION_TYPE_CARD_PRESENT":
            return PaymentAuthorizationType.AUTHORIZATION_TYPE_CARD_PRESENT;
        case 2:
        case "AUTHORIZATION_TYPE_CARD_PRESENT_OFFLINE":
            return PaymentAuthorizationType.AUTHORIZATION_TYPE_CARD_PRESENT_OFFLINE;
        case 3:
        case "AUTHORIZATION_TYPE_CARD_PRESENT_PHONE":
            return PaymentAuthorizationType.AUTHORIZATION_TYPE_CARD_PRESENT_PHONE;
        case 4:
        case "AUTHORIZATION_TYPE_REMOTE_AUTHORIZED_COMMAND_CONSOLE":
            return PaymentAuthorizationType.AUTHORIZATION_TYPE_REMOTE_AUTHORIZED_COMMAND_CONSOLE;
        case 5:
        case "AUTHORIZATION_TYPE_REMOTE_AUTHORIZED_OCPI":
            return PaymentAuthorizationType.AUTHORIZATION_TYPE_REMOTE_AUTHORIZED_OCPI;
        case 6:
        case "RESERVED":
            return PaymentAuthorizationType.RESERVED;
        case 7:
        case "AUTHORIZATION_TYPE_RFID_AUTHORIZED_OCPI":
            return PaymentAuthorizationType.AUTHORIZATION_TYPE_RFID_AUTHORIZED_OCPI;
        case 8:
        case "AUTHORIZATION_TYPE_REMOTE_AUTHORIZED_OCPP":
            return PaymentAuthorizationType.AUTHORIZATION_TYPE_REMOTE_AUTHORIZED_OCPP;
        case 9:
        case "AUTHORIZATION_TYPE_RFID_AUTHORIZED_OCPP":
            return PaymentAuthorizationType.AUTHORIZATION_TYPE_RFID_AUTHORIZED_OCPP;
        case -1:
        case "UNRECOGNIZED":
        default:
            return PaymentAuthorizationType.UNRECOGNIZED;
    }
}
exports.paymentAuthorizationTypeFromJSON = paymentAuthorizationTypeFromJSON;
function paymentAuthorizationTypeToJSON(object) {
    switch (object) {
        case PaymentAuthorizationType.AUTHORIZATION_TYPE_UNKNOWN:
            return "AUTHORIZATION_TYPE_UNKNOWN";
        case PaymentAuthorizationType.AUTHORIZATION_TYPE_CARD_PRESENT:
            return "AUTHORIZATION_TYPE_CARD_PRESENT";
        case PaymentAuthorizationType.AUTHORIZATION_TYPE_CARD_PRESENT_OFFLINE:
            return "AUTHORIZATION_TYPE_CARD_PRESENT_OFFLINE";
        case PaymentAuthorizationType.AUTHORIZATION_TYPE_CARD_PRESENT_PHONE:
            return "AUTHORIZATION_TYPE_CARD_PRESENT_PHONE";
        case PaymentAuthorizationType.AUTHORIZATION_TYPE_REMOTE_AUTHORIZED_COMMAND_CONSOLE:
            return "AUTHORIZATION_TYPE_REMOTE_AUTHORIZED_COMMAND_CONSOLE";
        case PaymentAuthorizationType.AUTHORIZATION_TYPE_REMOTE_AUTHORIZED_OCPI:
            return "AUTHORIZATION_TYPE_REMOTE_AUTHORIZED_OCPI";
        case PaymentAuthorizationType.RESERVED:
            return "RESERVED";
        case PaymentAuthorizationType.AUTHORIZATION_TYPE_RFID_AUTHORIZED_OCPI:
            return "AUTHORIZATION_TYPE_RFID_AUTHORIZED_OCPI";
        case PaymentAuthorizationType.AUTHORIZATION_TYPE_REMOTE_AUTHORIZED_OCPP:
            return "AUTHORIZATION_TYPE_REMOTE_AUTHORIZED_OCPP";
        case PaymentAuthorizationType.AUTHORIZATION_TYPE_RFID_AUTHORIZED_OCPP:
            return "AUTHORIZATION_TYPE_RFID_AUTHORIZED_OCPP";
        case PaymentAuthorizationType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.paymentAuthorizationTypeToJSON = paymentAuthorizationTypeToJSON;
/** The status of payment authorization for a given transaction. */
var PaymentAuthorizationStatus;
(function (PaymentAuthorizationStatus) {
    PaymentAuthorizationStatus[PaymentAuthorizationStatus["AUTHORIZATION_STATUS_UNKNOWN"] = 0] = "AUTHORIZATION_STATUS_UNKNOWN";
    PaymentAuthorizationStatus[PaymentAuthorizationStatus["AUTHORIZATION_STATUS_PENDING"] = 1] = "AUTHORIZATION_STATUS_PENDING";
    PaymentAuthorizationStatus[PaymentAuthorizationStatus["AUTHORIZATION_STATUS_COMPLETED_SUCCESSFULLY"] = 2] = "AUTHORIZATION_STATUS_COMPLETED_SUCCESSFULLY";
    PaymentAuthorizationStatus[PaymentAuthorizationStatus["AUTHORIZATION_STATUS_COMPLETED_FAILED_MAX_RETRIES"] = 3] = "AUTHORIZATION_STATUS_COMPLETED_FAILED_MAX_RETRIES";
    PaymentAuthorizationStatus[PaymentAuthorizationStatus["AUTHORIZATION_STATUS_COMPLETED_FAILED_VOIDED"] = 4] = "AUTHORIZATION_STATUS_COMPLETED_FAILED_VOIDED";
    PaymentAuthorizationStatus[PaymentAuthorizationStatus["AUTHORIZATION_STATUS_COMPLETED_FAILED_DECLINED"] = 5] = "AUTHORIZATION_STATUS_COMPLETED_FAILED_DECLINED";
    PaymentAuthorizationStatus[PaymentAuthorizationStatus["AUTHORIZATION_STATUS_COMPLETED_FAILED_FATAL"] = 6] = "AUTHORIZATION_STATUS_COMPLETED_FAILED_FATAL";
    PaymentAuthorizationStatus[PaymentAuthorizationStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(PaymentAuthorizationStatus = exports.PaymentAuthorizationStatus || (exports.PaymentAuthorizationStatus = {}));
function paymentAuthorizationStatusFromJSON(object) {
    switch (object) {
        case 0:
        case "AUTHORIZATION_STATUS_UNKNOWN":
            return PaymentAuthorizationStatus.AUTHORIZATION_STATUS_UNKNOWN;
        case 1:
        case "AUTHORIZATION_STATUS_PENDING":
            return PaymentAuthorizationStatus.AUTHORIZATION_STATUS_PENDING;
        case 2:
        case "AUTHORIZATION_STATUS_COMPLETED_SUCCESSFULLY":
            return PaymentAuthorizationStatus.AUTHORIZATION_STATUS_COMPLETED_SUCCESSFULLY;
        case 3:
        case "AUTHORIZATION_STATUS_COMPLETED_FAILED_MAX_RETRIES":
            return PaymentAuthorizationStatus.AUTHORIZATION_STATUS_COMPLETED_FAILED_MAX_RETRIES;
        case 4:
        case "AUTHORIZATION_STATUS_COMPLETED_FAILED_VOIDED":
            return PaymentAuthorizationStatus.AUTHORIZATION_STATUS_COMPLETED_FAILED_VOIDED;
        case 5:
        case "AUTHORIZATION_STATUS_COMPLETED_FAILED_DECLINED":
            return PaymentAuthorizationStatus.AUTHORIZATION_STATUS_COMPLETED_FAILED_DECLINED;
        case 6:
        case "AUTHORIZATION_STATUS_COMPLETED_FAILED_FATAL":
            return PaymentAuthorizationStatus.AUTHORIZATION_STATUS_COMPLETED_FAILED_FATAL;
        case -1:
        case "UNRECOGNIZED":
        default:
            return PaymentAuthorizationStatus.UNRECOGNIZED;
    }
}
exports.paymentAuthorizationStatusFromJSON = paymentAuthorizationStatusFromJSON;
function paymentAuthorizationStatusToJSON(object) {
    switch (object) {
        case PaymentAuthorizationStatus.AUTHORIZATION_STATUS_UNKNOWN:
            return "AUTHORIZATION_STATUS_UNKNOWN";
        case PaymentAuthorizationStatus.AUTHORIZATION_STATUS_PENDING:
            return "AUTHORIZATION_STATUS_PENDING";
        case PaymentAuthorizationStatus.AUTHORIZATION_STATUS_COMPLETED_SUCCESSFULLY:
            return "AUTHORIZATION_STATUS_COMPLETED_SUCCESSFULLY";
        case PaymentAuthorizationStatus.AUTHORIZATION_STATUS_COMPLETED_FAILED_MAX_RETRIES:
            return "AUTHORIZATION_STATUS_COMPLETED_FAILED_MAX_RETRIES";
        case PaymentAuthorizationStatus.AUTHORIZATION_STATUS_COMPLETED_FAILED_VOIDED:
            return "AUTHORIZATION_STATUS_COMPLETED_FAILED_VOIDED";
        case PaymentAuthorizationStatus.AUTHORIZATION_STATUS_COMPLETED_FAILED_DECLINED:
            return "AUTHORIZATION_STATUS_COMPLETED_FAILED_DECLINED";
        case PaymentAuthorizationStatus.AUTHORIZATION_STATUS_COMPLETED_FAILED_FATAL:
            return "AUTHORIZATION_STATUS_COMPLETED_FAILED_FATAL";
        case PaymentAuthorizationStatus.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.paymentAuthorizationStatusToJSON = paymentAuthorizationStatusToJSON;
/** The authorization mode that was used to perform membership authorization. */
var MembershipAuthorizationMode;
(function (MembershipAuthorizationMode) {
    MembershipAuthorizationMode[MembershipAuthorizationMode["MEMBERSHIP_MODE_UNKNOWN"] = 0] = "MEMBERSHIP_MODE_UNKNOWN";
    MembershipAuthorizationMode[MembershipAuthorizationMode["MEMBERSHIP_MODE_ONLINE"] = 1] = "MEMBERSHIP_MODE_ONLINE";
    MembershipAuthorizationMode[MembershipAuthorizationMode["MEMBERSHIP_MODE_OFFLINE"] = 2] = "MEMBERSHIP_MODE_OFFLINE";
    MembershipAuthorizationMode[MembershipAuthorizationMode["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(MembershipAuthorizationMode = exports.MembershipAuthorizationMode || (exports.MembershipAuthorizationMode = {}));
function membershipAuthorizationModeFromJSON(object) {
    switch (object) {
        case 0:
        case "MEMBERSHIP_MODE_UNKNOWN":
            return MembershipAuthorizationMode.MEMBERSHIP_MODE_UNKNOWN;
        case 1:
        case "MEMBERSHIP_MODE_ONLINE":
            return MembershipAuthorizationMode.MEMBERSHIP_MODE_ONLINE;
        case 2:
        case "MEMBERSHIP_MODE_OFFLINE":
            return MembershipAuthorizationMode.MEMBERSHIP_MODE_OFFLINE;
        case -1:
        case "UNRECOGNIZED":
        default:
            return MembershipAuthorizationMode.UNRECOGNIZED;
    }
}
exports.membershipAuthorizationModeFromJSON = membershipAuthorizationModeFromJSON;
function membershipAuthorizationModeToJSON(object) {
    switch (object) {
        case MembershipAuthorizationMode.MEMBERSHIP_MODE_UNKNOWN:
            return "MEMBERSHIP_MODE_UNKNOWN";
        case MembershipAuthorizationMode.MEMBERSHIP_MODE_ONLINE:
            return "MEMBERSHIP_MODE_ONLINE";
        case MembershipAuthorizationMode.MEMBERSHIP_MODE_OFFLINE:
            return "MEMBERSHIP_MODE_OFFLINE";
        case MembershipAuthorizationMode.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.membershipAuthorizationModeToJSON = membershipAuthorizationModeToJSON;
/** The authorization types of a membership card. */
var MembershipAuthorizationType;
(function (MembershipAuthorizationType) {
    MembershipAuthorizationType[MembershipAuthorizationType["MEMBERSHIP_TYPE_UNKNOWN"] = 0] = "MEMBERSHIP_TYPE_UNKNOWN";
    MembershipAuthorizationType[MembershipAuthorizationType["MEMBERSHIP_TYPE_CARD_TAP"] = 1] = "MEMBERSHIP_TYPE_CARD_TAP";
    MembershipAuthorizationType[MembershipAuthorizationType["MEMBERSHIP_TYPE_CARD_INSERT"] = 2] = "MEMBERSHIP_TYPE_CARD_INSERT";
    MembershipAuthorizationType[MembershipAuthorizationType["MEMBERSHIP_TYPE_CARD_SWIPE"] = 3] = "MEMBERSHIP_TYPE_CARD_SWIPE";
    MembershipAuthorizationType[MembershipAuthorizationType["MEMBERSHIP_TYPE_PHONE_NUMBER"] = 4] = "MEMBERSHIP_TYPE_PHONE_NUMBER";
    MembershipAuthorizationType[MembershipAuthorizationType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(MembershipAuthorizationType = exports.MembershipAuthorizationType || (exports.MembershipAuthorizationType = {}));
function membershipAuthorizationTypeFromJSON(object) {
    switch (object) {
        case 0:
        case "MEMBERSHIP_TYPE_UNKNOWN":
            return MembershipAuthorizationType.MEMBERSHIP_TYPE_UNKNOWN;
        case 1:
        case "MEMBERSHIP_TYPE_CARD_TAP":
            return MembershipAuthorizationType.MEMBERSHIP_TYPE_CARD_TAP;
        case 2:
        case "MEMBERSHIP_TYPE_CARD_INSERT":
            return MembershipAuthorizationType.MEMBERSHIP_TYPE_CARD_INSERT;
        case 3:
        case "MEMBERSHIP_TYPE_CARD_SWIPE":
            return MembershipAuthorizationType.MEMBERSHIP_TYPE_CARD_SWIPE;
        case 4:
        case "MEMBERSHIP_TYPE_PHONE_NUMBER":
            return MembershipAuthorizationType.MEMBERSHIP_TYPE_PHONE_NUMBER;
        case -1:
        case "UNRECOGNIZED":
        default:
            return MembershipAuthorizationType.UNRECOGNIZED;
    }
}
exports.membershipAuthorizationTypeFromJSON = membershipAuthorizationTypeFromJSON;
function membershipAuthorizationTypeToJSON(object) {
    switch (object) {
        case MembershipAuthorizationType.MEMBERSHIP_TYPE_UNKNOWN:
            return "MEMBERSHIP_TYPE_UNKNOWN";
        case MembershipAuthorizationType.MEMBERSHIP_TYPE_CARD_TAP:
            return "MEMBERSHIP_TYPE_CARD_TAP";
        case MembershipAuthorizationType.MEMBERSHIP_TYPE_CARD_INSERT:
            return "MEMBERSHIP_TYPE_CARD_INSERT";
        case MembershipAuthorizationType.MEMBERSHIP_TYPE_CARD_SWIPE:
            return "MEMBERSHIP_TYPE_CARD_SWIPE";
        case MembershipAuthorizationType.MEMBERSHIP_TYPE_PHONE_NUMBER:
            return "MEMBERSHIP_TYPE_PHONE_NUMBER";
        case MembershipAuthorizationType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.membershipAuthorizationTypeToJSON = membershipAuthorizationTypeToJSON;
/** Why was a session transaction free? */
var FreeReason;
(function (FreeReason) {
    /** UNKNOWN - There are reasons not captured here. */
    FreeReason[FreeReason["UNKNOWN"] = 0] = "UNKNOWN";
    /** NOT_APPLICABLE - Session was not free. */
    FreeReason[FreeReason["NOT_APPLICABLE"] = 1] = "NOT_APPLICABLE";
    /** SUPPORT_AGENT_FREE_SESSION - A support agent made the session free to help a customer. */
    FreeReason[FreeReason["SUPPORT_AGENT_FREE_SESSION"] = 2] = "SUPPORT_AGENT_FREE_SESSION";
    /** FREE_MODE - The station was in free mode. */
    FreeReason[FreeReason["FREE_MODE"] = 3] = "FREE_MODE";
    /** FORCE_START_TRANSACTIONS - The charger was configured to force start all transactions. */
    FreeReason[FreeReason["FORCE_START_TRANSACTIONS"] = 4] = "FORCE_START_TRANSACTIONS";
    /** NO_ENERGY_DISPENSED - There was zero, or very close to zero, energy dispensed. */
    FreeReason[FreeReason["NO_ENERGY_DISPENSED"] = 5] = "NO_ENERGY_DISPENSED";
    /** UNABLE_TO_CALCULATE_ENERGY_DISPENSED - There was an error calculating the energy dispensed. */
    FreeReason[FreeReason["UNABLE_TO_CALCULATE_ENERGY_DISPENSED"] = 6] = "UNABLE_TO_CALCULATE_ENERGY_DISPENSED";
    /** NO_PAYMENT_DEVICE - No payment device found for charger */
    FreeReason[FreeReason["NO_PAYMENT_DEVICE"] = 7] = "NO_PAYMENT_DEVICE";
    /** FAILED_TO_PROCESS_SALE - Failed to process sale */
    FreeReason[FreeReason["FAILED_TO_PROCESS_SALE"] = 8] = "FAILED_TO_PROCESS_SALE";
    /** UNABLE_TO_FIND_PAYMENT - Unable to find payment for port */
    FreeReason[FreeReason["UNABLE_TO_FIND_PAYMENT"] = 9] = "UNABLE_TO_FIND_PAYMENT";
    FreeReason[FreeReason["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(FreeReason = exports.FreeReason || (exports.FreeReason = {}));
function freeReasonFromJSON(object) {
    switch (object) {
        case 0:
        case "UNKNOWN":
            return FreeReason.UNKNOWN;
        case 1:
        case "NOT_APPLICABLE":
            return FreeReason.NOT_APPLICABLE;
        case 2:
        case "SUPPORT_AGENT_FREE_SESSION":
            return FreeReason.SUPPORT_AGENT_FREE_SESSION;
        case 3:
        case "FREE_MODE":
            return FreeReason.FREE_MODE;
        case 4:
        case "FORCE_START_TRANSACTIONS":
            return FreeReason.FORCE_START_TRANSACTIONS;
        case 5:
        case "NO_ENERGY_DISPENSED":
            return FreeReason.NO_ENERGY_DISPENSED;
        case 6:
        case "UNABLE_TO_CALCULATE_ENERGY_DISPENSED":
            return FreeReason.UNABLE_TO_CALCULATE_ENERGY_DISPENSED;
        case 7:
        case "NO_PAYMENT_DEVICE":
            return FreeReason.NO_PAYMENT_DEVICE;
        case 8:
        case "FAILED_TO_PROCESS_SALE":
            return FreeReason.FAILED_TO_PROCESS_SALE;
        case 9:
        case "UNABLE_TO_FIND_PAYMENT":
            return FreeReason.UNABLE_TO_FIND_PAYMENT;
        case -1:
        case "UNRECOGNIZED":
        default:
            return FreeReason.UNRECOGNIZED;
    }
}
exports.freeReasonFromJSON = freeReasonFromJSON;
function freeReasonToJSON(object) {
    switch (object) {
        case FreeReason.UNKNOWN:
            return "UNKNOWN";
        case FreeReason.NOT_APPLICABLE:
            return "NOT_APPLICABLE";
        case FreeReason.SUPPORT_AGENT_FREE_SESSION:
            return "SUPPORT_AGENT_FREE_SESSION";
        case FreeReason.FREE_MODE:
            return "FREE_MODE";
        case FreeReason.FORCE_START_TRANSACTIONS:
            return "FORCE_START_TRANSACTIONS";
        case FreeReason.NO_ENERGY_DISPENSED:
            return "NO_ENERGY_DISPENSED";
        case FreeReason.UNABLE_TO_CALCULATE_ENERGY_DISPENSED:
            return "UNABLE_TO_CALCULATE_ENERGY_DISPENSED";
        case FreeReason.NO_PAYMENT_DEVICE:
            return "NO_PAYMENT_DEVICE";
        case FreeReason.FAILED_TO_PROCESS_SALE:
            return "FAILED_TO_PROCESS_SALE";
        case FreeReason.UNABLE_TO_FIND_PAYMENT:
            return "UNABLE_TO_FIND_PAYMENT";
        case FreeReason.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.freeReasonToJSON = freeReasonToJSON;
/** A type of surcharge. Different surcharges must be handled differently. For example, taxes are applied additively on top of each other and are applied after all other surcharges. */
var SurchargeType;
(function (SurchargeType) {
    SurchargeType[SurchargeType["SURCHARGE_UNKNOWN"] = 0] = "SURCHARGE_UNKNOWN";
    SurchargeType[SurchargeType["SURCHARGE_TAX"] = 1] = "SURCHARGE_TAX";
    SurchargeType[SurchargeType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SurchargeType = exports.SurchargeType || (exports.SurchargeType = {}));
function surchargeTypeFromJSON(object) {
    switch (object) {
        case 0:
        case "SURCHARGE_UNKNOWN":
            return SurchargeType.SURCHARGE_UNKNOWN;
        case 1:
        case "SURCHARGE_TAX":
            return SurchargeType.SURCHARGE_TAX;
        case -1:
        case "UNRECOGNIZED":
        default:
            return SurchargeType.UNRECOGNIZED;
    }
}
exports.surchargeTypeFromJSON = surchargeTypeFromJSON;
function surchargeTypeToJSON(object) {
    switch (object) {
        case SurchargeType.SURCHARGE_UNKNOWN:
            return "SURCHARGE_UNKNOWN";
        case SurchargeType.SURCHARGE_TAX:
            return "SURCHARGE_TAX";
        case SurchargeType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.surchargeTypeToJSON = surchargeTypeToJSON;
/** An error when paying by card. */
var CardPaymentError;
(function (CardPaymentError) {
    /** CARD_READ_ERROR - Error trying to read the card. */
    CardPaymentError[CardPaymentError["CARD_READ_ERROR"] = 0] = "CARD_READ_ERROR";
    /** PAYMENT_REJECTED - General error for a rejected payment. */
    CardPaymentError[CardPaymentError["PAYMENT_REJECTED"] = 1] = "PAYMENT_REJECTED";
    /** PAYMENT_REJECTED_VISA_DEBIT_NOT_SUPPORTED - Payment rejected because Visa debit is not supported by this MOR. */
    CardPaymentError[CardPaymentError["PAYMENT_REJECTED_VISA_DEBIT_NOT_SUPPORTED"] = 2] = "PAYMENT_REJECTED_VISA_DEBIT_NOT_SUPPORTED";
    /** PAYMENT_REJECTED_MASTERCARD_DEBIT_NOT_SUPPORTED - Payment rejected because Mastercard debit is not supported by this MOR. */
    CardPaymentError[CardPaymentError["PAYMENT_REJECTED_MASTERCARD_DEBIT_NOT_SUPPORTED"] = 3] = "PAYMENT_REJECTED_MASTERCARD_DEBIT_NOT_SUPPORTED";
    /** PAYMENT_REJECTED_VISA_CREDIT_NOT_SUPPORTED - Payment rejected because Visa credit is not supported by this MOR. */
    CardPaymentError[CardPaymentError["PAYMENT_REJECTED_VISA_CREDIT_NOT_SUPPORTED"] = 6] = "PAYMENT_REJECTED_VISA_CREDIT_NOT_SUPPORTED";
    /** PAYMENT_REJECTED_MASTERCARD_CREDIT_NOT_SUPPORTED - Payment rejected because Mastercard credit is not supported by this MOR. */
    CardPaymentError[CardPaymentError["PAYMENT_REJECTED_MASTERCARD_CREDIT_NOT_SUPPORTED"] = 7] = "PAYMENT_REJECTED_MASTERCARD_CREDIT_NOT_SUPPORTED";
    /** PAYMENT_REJECTED_AMEX_NOT_SUPPORTED - Payment rejected because American Express credit is not supported by this MOR. */
    CardPaymentError[CardPaymentError["PAYMENT_REJECTED_AMEX_NOT_SUPPORTED"] = 8] = "PAYMENT_REJECTED_AMEX_NOT_SUPPORTED";
    /** PAYMENT_REJECTED_DISCOVER_NOT_SUPPORTED - Payment rejected because Discover credit is not supported by this MOR. */
    CardPaymentError[CardPaymentError["PAYMENT_REJECTED_DISCOVER_NOT_SUPPORTED"] = 9] = "PAYMENT_REJECTED_DISCOVER_NOT_SUPPORTED";
    /** PAYMENT_REJECTED_DEFAULT_PAYMENT_RESTRICTED - Payment rejected because of payment restrictions that will have messaging that is pretty generic. */
    CardPaymentError[CardPaymentError["PAYMENT_REJECTED_DEFAULT_PAYMENT_RESTRICTED"] = 10] = "PAYMENT_REJECTED_DEFAULT_PAYMENT_RESTRICTED";
    /**
     * PAYMENT_REJECTED_COSTCO_PAYMENT_RESTRICTED - Payment rejected because of costco payment restrictions that will have messaging specific for
     * Costco.
     */
    CardPaymentError[CardPaymentError["PAYMENT_REJECTED_COSTCO_PAYMENT_RESTRICTED"] = 11] = "PAYMENT_REJECTED_COSTCO_PAYMENT_RESTRICTED";
    /**
     * PAYMENT_DECLINED - Payment declined due to either a decline from the bank or void which is considered only
     * partial enough funds.
     */
    CardPaymentError[CardPaymentError["PAYMENT_DECLINED"] = 12] = "PAYMENT_DECLINED";
    /** RFID_AUTHORIZATION_FAILED - An RFID Card authorization request was rejected. */
    CardPaymentError[CardPaymentError["RFID_AUTHORIZATION_FAILED"] = 13] = "RFID_AUTHORIZATION_FAILED";
    CardPaymentError[CardPaymentError["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CardPaymentError = exports.CardPaymentError || (exports.CardPaymentError = {}));
function cardPaymentErrorFromJSON(object) {
    switch (object) {
        case 0:
        case "CARD_READ_ERROR":
            return CardPaymentError.CARD_READ_ERROR;
        case 1:
        case "PAYMENT_REJECTED":
            return CardPaymentError.PAYMENT_REJECTED;
        case 2:
        case "PAYMENT_REJECTED_VISA_DEBIT_NOT_SUPPORTED":
            return CardPaymentError.PAYMENT_REJECTED_VISA_DEBIT_NOT_SUPPORTED;
        case 3:
        case "PAYMENT_REJECTED_MASTERCARD_DEBIT_NOT_SUPPORTED":
            return CardPaymentError.PAYMENT_REJECTED_MASTERCARD_DEBIT_NOT_SUPPORTED;
        case 6:
        case "PAYMENT_REJECTED_VISA_CREDIT_NOT_SUPPORTED":
            return CardPaymentError.PAYMENT_REJECTED_VISA_CREDIT_NOT_SUPPORTED;
        case 7:
        case "PAYMENT_REJECTED_MASTERCARD_CREDIT_NOT_SUPPORTED":
            return CardPaymentError.PAYMENT_REJECTED_MASTERCARD_CREDIT_NOT_SUPPORTED;
        case 8:
        case "PAYMENT_REJECTED_AMEX_NOT_SUPPORTED":
            return CardPaymentError.PAYMENT_REJECTED_AMEX_NOT_SUPPORTED;
        case 9:
        case "PAYMENT_REJECTED_DISCOVER_NOT_SUPPORTED":
            return CardPaymentError.PAYMENT_REJECTED_DISCOVER_NOT_SUPPORTED;
        case 10:
        case "PAYMENT_REJECTED_DEFAULT_PAYMENT_RESTRICTED":
            return CardPaymentError.PAYMENT_REJECTED_DEFAULT_PAYMENT_RESTRICTED;
        case 11:
        case "PAYMENT_REJECTED_COSTCO_PAYMENT_RESTRICTED":
            return CardPaymentError.PAYMENT_REJECTED_COSTCO_PAYMENT_RESTRICTED;
        case 12:
        case "PAYMENT_DECLINED":
            return CardPaymentError.PAYMENT_DECLINED;
        case 13:
        case "RFID_AUTHORIZATION_FAILED":
            return CardPaymentError.RFID_AUTHORIZATION_FAILED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return CardPaymentError.UNRECOGNIZED;
    }
}
exports.cardPaymentErrorFromJSON = cardPaymentErrorFromJSON;
function cardPaymentErrorToJSON(object) {
    switch (object) {
        case CardPaymentError.CARD_READ_ERROR:
            return "CARD_READ_ERROR";
        case CardPaymentError.PAYMENT_REJECTED:
            return "PAYMENT_REJECTED";
        case CardPaymentError.PAYMENT_REJECTED_VISA_DEBIT_NOT_SUPPORTED:
            return "PAYMENT_REJECTED_VISA_DEBIT_NOT_SUPPORTED";
        case CardPaymentError.PAYMENT_REJECTED_MASTERCARD_DEBIT_NOT_SUPPORTED:
            return "PAYMENT_REJECTED_MASTERCARD_DEBIT_NOT_SUPPORTED";
        case CardPaymentError.PAYMENT_REJECTED_VISA_CREDIT_NOT_SUPPORTED:
            return "PAYMENT_REJECTED_VISA_CREDIT_NOT_SUPPORTED";
        case CardPaymentError.PAYMENT_REJECTED_MASTERCARD_CREDIT_NOT_SUPPORTED:
            return "PAYMENT_REJECTED_MASTERCARD_CREDIT_NOT_SUPPORTED";
        case CardPaymentError.PAYMENT_REJECTED_AMEX_NOT_SUPPORTED:
            return "PAYMENT_REJECTED_AMEX_NOT_SUPPORTED";
        case CardPaymentError.PAYMENT_REJECTED_DISCOVER_NOT_SUPPORTED:
            return "PAYMENT_REJECTED_DISCOVER_NOT_SUPPORTED";
        case CardPaymentError.PAYMENT_REJECTED_DEFAULT_PAYMENT_RESTRICTED:
            return "PAYMENT_REJECTED_DEFAULT_PAYMENT_RESTRICTED";
        case CardPaymentError.PAYMENT_REJECTED_COSTCO_PAYMENT_RESTRICTED:
            return "PAYMENT_REJECTED_COSTCO_PAYMENT_RESTRICTED";
        case CardPaymentError.PAYMENT_DECLINED:
            return "PAYMENT_DECLINED";
        case CardPaymentError.RFID_AUTHORIZATION_FAILED:
            return "RFID_AUTHORIZATION_FAILED";
        case CardPaymentError.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.cardPaymentErrorToJSON = cardPaymentErrorToJSON;
/** An enum representing the different card networks. */
var CardNetwork;
(function (CardNetwork) {
    /** ALL - If we are permissive on all networks before sending to the payment provider. */
    CardNetwork[CardNetwork["ALL"] = 0] = "ALL";
    /** VISA - The Visa Network. */
    CardNetwork[CardNetwork["VISA"] = 1] = "VISA";
    /** MASTERCARD - The Mastercard Network. */
    CardNetwork[CardNetwork["MASTERCARD"] = 2] = "MASTERCARD";
    /** AMERICAN_EXPRESS - The American Express Network. */
    CardNetwork[CardNetwork["AMERICAN_EXPRESS"] = 3] = "AMERICAN_EXPRESS";
    /** DISCOVER - The Discover Network. */
    CardNetwork[CardNetwork["DISCOVER"] = 4] = "DISCOVER";
    CardNetwork[CardNetwork["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CardNetwork = exports.CardNetwork || (exports.CardNetwork = {}));
function cardNetworkFromJSON(object) {
    switch (object) {
        case 0:
        case "ALL":
            return CardNetwork.ALL;
        case 1:
        case "VISA":
            return CardNetwork.VISA;
        case 2:
        case "MASTERCARD":
            return CardNetwork.MASTERCARD;
        case 3:
        case "AMERICAN_EXPRESS":
            return CardNetwork.AMERICAN_EXPRESS;
        case 4:
        case "DISCOVER":
            return CardNetwork.DISCOVER;
        case -1:
        case "UNRECOGNIZED":
        default:
            return CardNetwork.UNRECOGNIZED;
    }
}
exports.cardNetworkFromJSON = cardNetworkFromJSON;
function cardNetworkToJSON(object) {
    switch (object) {
        case CardNetwork.ALL:
            return "ALL";
        case CardNetwork.VISA:
            return "VISA";
        case CardNetwork.MASTERCARD:
            return "MASTERCARD";
        case CardNetwork.AMERICAN_EXPRESS:
            return "AMERICAN_EXPRESS";
        case CardNetwork.DISCOVER:
            return "DISCOVER";
        case CardNetwork.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.cardNetworkToJSON = cardNetworkToJSON;
function createBaseMoney() {
    return { currencyCode: "", amount: 0, precision: 0 };
}
exports.Money = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.currencyCode !== "") {
            writer.uint32(10).string(message.currencyCode);
        }
        if (message.amount !== 0) {
            writer.uint32(16).int32(message.amount);
        }
        if (message.precision !== 0) {
            writer.uint32(24).uint32(message.precision);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMoney();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.currencyCode = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.amount = reader.int32();
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.precision = reader.uint32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            currencyCode: isSet(object.currencyCode)
                ? globalThis.String(object.currencyCode)
                : isSet(object.currency_code)
                    ? globalThis.String(object.currency_code)
                    : "",
            amount: isSet(object.amount) ? globalThis.Number(object.amount) : 0,
            precision: isSet(object.precision)
                ? globalThis.Number(object.precision)
                : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.currencyCode !== "") {
            obj.currencyCode = message.currencyCode;
        }
        if (message.amount !== 0) {
            obj.amount = Math.round(message.amount);
        }
        if (message.precision !== 0) {
            obj.precision = Math.round(message.precision);
        }
        return obj;
    },
    create(base) {
        return exports.Money.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMoney();
        message.currencyCode = object.currencyCode ?? "";
        message.amount = object.amount ?? 0;
        message.precision = object.precision ?? 0;
        return message;
    },
};
function createBaseSurcharge() {
    return { name: "", type: 0, percentage: 0 };
}
exports.Surcharge = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.name !== "") {
            writer.uint32(10).string(message.name);
        }
        if (message.type !== 0) {
            writer.uint32(16).int32(message.type);
        }
        if (message.percentage !== 0) {
            writer.uint32(25).double(message.percentage);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSurcharge();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.type = reader.int32();
                    continue;
                }
                case 3: {
                    if (tag !== 25) {
                        break;
                    }
                    message.percentage = reader.double();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            name: isSet(object.name) ? globalThis.String(object.name) : "",
            type: isSet(object.type) ? surchargeTypeFromJSON(object.type) : 0,
            percentage: isSet(object.percentage)
                ? globalThis.Number(object.percentage)
                : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.name !== "") {
            obj.name = message.name;
        }
        if (message.type !== 0) {
            obj.type = surchargeTypeToJSON(message.type);
        }
        if (message.percentage !== 0) {
            obj.percentage = message.percentage;
        }
        return obj;
    },
    create(base) {
        return exports.Surcharge.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSurcharge();
        message.name = object.name ?? "";
        message.type = object.type ?? 0;
        message.percentage = object.percentage ?? 0;
        return message;
    },
};
function createBaseChargeBreakdown() {
    return {
        baseCharge: undefined,
        surcharges: [],
        idleFeesAfterChargingStarts: undefined,
        idleFeesAfterChargingEnds: undefined,
    };
}
exports.ChargeBreakdown = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.baseCharge !== undefined) {
            exports.Money.encode(message.baseCharge, writer.uint32(10).fork()).join();
        }
        for (const v of message.surcharges) {
            exports.ChargeBreakdown_SurchargeBreakdown.encode(v, writer.uint32(42).fork()).join();
        }
        if (message.idleFeesAfterChargingStarts !== undefined) {
            exports.ChargeBreakdown_TimeBasedCharge.encode(message.idleFeesAfterChargingStarts, writer.uint32(26).fork()).join();
        }
        if (message.idleFeesAfterChargingEnds !== undefined) {
            exports.ChargeBreakdown_TimeBasedCharge.encode(message.idleFeesAfterChargingEnds, writer.uint32(34).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChargeBreakdown();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.baseCharge = exports.Money.decode(reader, reader.uint32());
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.surcharges.push(exports.ChargeBreakdown_SurchargeBreakdown.decode(reader, reader.uint32()));
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.idleFeesAfterChargingStarts =
                        exports.ChargeBreakdown_TimeBasedCharge.decode(reader, reader.uint32());
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.idleFeesAfterChargingEnds =
                        exports.ChargeBreakdown_TimeBasedCharge.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            baseCharge: isSet(object.baseCharge)
                ? exports.Money.fromJSON(object.baseCharge)
                : isSet(object.base_charge)
                    ? exports.Money.fromJSON(object.base_charge)
                    : undefined,
            surcharges: globalThis.Array.isArray(object?.surcharges)
                ? object.surcharges.map((e) => exports.ChargeBreakdown_SurchargeBreakdown.fromJSON(e))
                : [],
            idleFeesAfterChargingStarts: isSet(object.idleFeesAfterChargingStarts)
                ? exports.ChargeBreakdown_TimeBasedCharge.fromJSON(object.idleFeesAfterChargingStarts)
                : isSet(object.idle_fees_after_charging_starts)
                    ? exports.ChargeBreakdown_TimeBasedCharge.fromJSON(object.idle_fees_after_charging_starts)
                    : undefined,
            idleFeesAfterChargingEnds: isSet(object.idleFeesAfterChargingEnds)
                ? exports.ChargeBreakdown_TimeBasedCharge.fromJSON(object.idleFeesAfterChargingEnds)
                : isSet(object.idle_fees_after_charging_ends)
                    ? exports.ChargeBreakdown_TimeBasedCharge.fromJSON(object.idle_fees_after_charging_ends)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.baseCharge !== undefined) {
            obj.baseCharge = exports.Money.toJSON(message.baseCharge);
        }
        if (message.surcharges?.length) {
            obj.surcharges = message.surcharges.map((e) => exports.ChargeBreakdown_SurchargeBreakdown.toJSON(e));
        }
        if (message.idleFeesAfterChargingStarts !== undefined) {
            obj.idleFeesAfterChargingStarts = exports.ChargeBreakdown_TimeBasedCharge.toJSON(message.idleFeesAfterChargingStarts);
        }
        if (message.idleFeesAfterChargingEnds !== undefined) {
            obj.idleFeesAfterChargingEnds = exports.ChargeBreakdown_TimeBasedCharge.toJSON(message.idleFeesAfterChargingEnds);
        }
        return obj;
    },
    create(base) {
        return exports.ChargeBreakdown.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseChargeBreakdown();
        message.baseCharge =
            object.baseCharge !== undefined && object.baseCharge !== null
                ? exports.Money.fromPartial(object.baseCharge)
                : undefined;
        message.surcharges =
            object.surcharges?.map((e) => exports.ChargeBreakdown_SurchargeBreakdown.fromPartial(e)) || [];
        message.idleFeesAfterChargingStarts =
            object.idleFeesAfterChargingStarts !== undefined &&
                object.idleFeesAfterChargingStarts !== null
                ? exports.ChargeBreakdown_TimeBasedCharge.fromPartial(object.idleFeesAfterChargingStarts)
                : undefined;
        message.idleFeesAfterChargingEnds =
            object.idleFeesAfterChargingEnds !== undefined &&
                object.idleFeesAfterChargingEnds !== null
                ? exports.ChargeBreakdown_TimeBasedCharge.fromPartial(object.idleFeesAfterChargingEnds)
                : undefined;
        return message;
    },
};
function createBaseChargeBreakdown_SurchargeBreakdown() {
    return { charge: undefined, amount: undefined };
}
exports.ChargeBreakdown_SurchargeBreakdown = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.charge !== undefined) {
            exports.Surcharge.encode(message.charge, writer.uint32(10).fork()).join();
        }
        if (message.amount !== undefined) {
            exports.Money.encode(message.amount, writer.uint32(18).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChargeBreakdown_SurchargeBreakdown();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.charge = exports.Surcharge.decode(reader, reader.uint32());
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.amount = exports.Money.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            charge: isSet(object.charge)
                ? exports.Surcharge.fromJSON(object.charge)
                : undefined,
            amount: isSet(object.amount)
                ? exports.Money.fromJSON(object.amount)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.charge !== undefined) {
            obj.charge = exports.Surcharge.toJSON(message.charge);
        }
        if (message.amount !== undefined) {
            obj.amount = exports.Money.toJSON(message.amount);
        }
        return obj;
    },
    create(base) {
        return exports.ChargeBreakdown_SurchargeBreakdown.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseChargeBreakdown_SurchargeBreakdown();
        message.charge =
            object.charge !== undefined && object.charge !== null
                ? exports.Surcharge.fromPartial(object.charge)
                : undefined;
        message.amount =
            object.amount !== undefined && object.amount !== null
                ? exports.Money.fromPartial(object.amount)
                : undefined;
        return message;
    },
};
function createBaseChargeBreakdown_TimeBasedCharge() {
    return { timeBeginUtc: undefined, timeEndUtc: undefined, amount: undefined };
}
exports.ChargeBreakdown_TimeBasedCharge = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.timeBeginUtc !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.timeBeginUtc), writer.uint32(10).fork()).join();
        }
        if (message.timeEndUtc !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.timeEndUtc), writer.uint32(18).fork()).join();
        }
        if (message.amount !== undefined) {
            exports.Money.encode(message.amount, writer.uint32(26).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChargeBreakdown_TimeBasedCharge();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.timeBeginUtc = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.timeEndUtc = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.amount = exports.Money.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            timeBeginUtc: isSet(object.timeBeginUtc)
                ? fromJsonTimestamp(object.timeBeginUtc)
                : isSet(object.time_begin_utc)
                    ? fromJsonTimestamp(object.time_begin_utc)
                    : undefined,
            timeEndUtc: isSet(object.timeEndUtc)
                ? fromJsonTimestamp(object.timeEndUtc)
                : isSet(object.time_end_utc)
                    ? fromJsonTimestamp(object.time_end_utc)
                    : undefined,
            amount: isSet(object.amount)
                ? exports.Money.fromJSON(object.amount)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.timeBeginUtc !== undefined) {
            obj.timeBeginUtc = message.timeBeginUtc.toISOString();
        }
        if (message.timeEndUtc !== undefined) {
            obj.timeEndUtc = message.timeEndUtc.toISOString();
        }
        if (message.amount !== undefined) {
            obj.amount = exports.Money.toJSON(message.amount);
        }
        return obj;
    },
    create(base) {
        return exports.ChargeBreakdown_TimeBasedCharge.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseChargeBreakdown_TimeBasedCharge();
        message.timeBeginUtc = object.timeBeginUtc ?? undefined;
        message.timeEndUtc = object.timeEndUtc ?? undefined;
        message.amount =
            object.amount !== undefined && object.amount !== null
                ? exports.Money.fromPartial(object.amount)
                : undefined;
        return message;
    },
};
function createBasePricePerKWH() {
    return { amount: undefined };
}
exports.PricePerKWH = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.amount !== undefined) {
            exports.Money.encode(message.amount, writer.uint32(18).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePricePerKWH();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.amount = exports.Money.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            amount: isSet(object.amount) ? exports.Money.fromJSON(object.amount) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.amount !== undefined) {
            obj.amount = exports.Money.toJSON(message.amount);
        }
        return obj;
    },
    create(base) {
        return exports.PricePerKWH.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePricePerKWH();
        message.amount =
            object.amount !== undefined && object.amount !== null
                ? exports.Money.fromPartial(object.amount)
                : undefined;
        return message;
    },
};
function createBasePricePerMinuteTier() {
    return { maxRateKw: 0, pricePerMinute: 0 };
}
exports.PricePerMinuteTier = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.maxRateKw !== 0) {
            writer.uint32(8).int32(message.maxRateKw);
        }
        if (message.pricePerMinute !== 0) {
            writer.uint32(21).float(message.pricePerMinute);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePricePerMinuteTier();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.maxRateKw = reader.int32();
                    continue;
                }
                case 2: {
                    if (tag !== 21) {
                        break;
                    }
                    message.pricePerMinute = reader.float();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            maxRateKw: isSet(object.maxRateKw)
                ? globalThis.Number(object.maxRateKw)
                : isSet(object.max_rate_kw)
                    ? globalThis.Number(object.max_rate_kw)
                    : 0,
            pricePerMinute: isSet(object.pricePerMinute)
                ? globalThis.Number(object.pricePerMinute)
                : isSet(object.price_per_minute)
                    ? globalThis.Number(object.price_per_minute)
                    : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.maxRateKw !== 0) {
            obj.maxRateKw = Math.round(message.maxRateKw);
        }
        if (message.pricePerMinute !== 0) {
            obj.pricePerMinute = message.pricePerMinute;
        }
        return obj;
    },
    create(base) {
        return exports.PricePerMinuteTier.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePricePerMinuteTier();
        message.maxRateKw = object.maxRateKw ?? 0;
        message.pricePerMinute = object.pricePerMinute ?? 0;
        return message;
    },
};
function createBasePricePerMinute() {
    return { tiers: [] };
}
exports.PricePerMinute = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        for (const v of message.tiers) {
            exports.PricePerMinuteTier.encode(v, writer.uint32(10).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePricePerMinute();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.tiers.push(exports.PricePerMinuteTier.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            tiers: globalThis.Array.isArray(object?.tiers)
                ? object.tiers.map((e) => exports.PricePerMinuteTier.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.tiers?.length) {
            obj.tiers = message.tiers.map((e) => exports.PricePerMinuteTier.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.PricePerMinute.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePricePerMinute();
        message.tiers =
            object.tiers?.map((e) => exports.PricePerMinuteTier.fromPartial(e)) || [];
        return message;
    },
};
function createBaseFreemode() {
    return { previousPricingModel: undefined };
}
exports.Freemode = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.previousPricingModel !== undefined) {
            exports.PricingModel.encode(message.previousPricingModel, writer.uint32(10).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFreemode();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.previousPricingModel = exports.PricingModel.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            previousPricingModel: isSet(object.previousPricingModel)
                ? exports.PricingModel.fromJSON(object.previousPricingModel)
                : isSet(object.previous_pricing_model)
                    ? exports.PricingModel.fromJSON(object.previous_pricing_model)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.previousPricingModel !== undefined) {
            obj.previousPricingModel = exports.PricingModel.toJSON(message.previousPricingModel);
        }
        return obj;
    },
    create(base) {
        return exports.Freemode.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFreemode();
        message.previousPricingModel =
            object.previousPricingModel !== undefined &&
                object.previousPricingModel !== null
                ? exports.PricingModel.fromPartial(object.previousPricingModel)
                : undefined;
        return message;
    },
};
function createBaseIdleFees() {
    return {
        amountPerMinute: undefined,
        gracePeriodMinutes: 0,
        maxAmount: undefined,
    };
}
exports.IdleFees = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.amountPerMinute !== undefined) {
            exports.Money.encode(message.amountPerMinute, writer.uint32(10).fork()).join();
        }
        if (message.gracePeriodMinutes !== 0) {
            writer.uint32(16).uint32(message.gracePeriodMinutes);
        }
        if (message.maxAmount !== undefined) {
            exports.Money.encode(message.maxAmount, writer.uint32(26).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseIdleFees();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.amountPerMinute = exports.Money.decode(reader, reader.uint32());
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.gracePeriodMinutes = reader.uint32();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.maxAmount = exports.Money.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            amountPerMinute: isSet(object.amountPerMinute)
                ? exports.Money.fromJSON(object.amountPerMinute)
                : isSet(object.amount_per_minute)
                    ? exports.Money.fromJSON(object.amount_per_minute)
                    : undefined,
            gracePeriodMinutes: isSet(object.gracePeriodMinutes)
                ? globalThis.Number(object.gracePeriodMinutes)
                : isSet(object.grace_period_minutes)
                    ? globalThis.Number(object.grace_period_minutes)
                    : 0,
            maxAmount: isSet(object.maxAmount)
                ? exports.Money.fromJSON(object.maxAmount)
                : isSet(object.max_amount)
                    ? exports.Money.fromJSON(object.max_amount)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.amountPerMinute !== undefined) {
            obj.amountPerMinute = exports.Money.toJSON(message.amountPerMinute);
        }
        if (message.gracePeriodMinutes !== 0) {
            obj.gracePeriodMinutes = Math.round(message.gracePeriodMinutes);
        }
        if (message.maxAmount !== undefined) {
            obj.maxAmount = exports.Money.toJSON(message.maxAmount);
        }
        return obj;
    },
    create(base) {
        return exports.IdleFees.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseIdleFees();
        message.amountPerMinute =
            object.amountPerMinute !== undefined && object.amountPerMinute !== null
                ? exports.Money.fromPartial(object.amountPerMinute)
                : undefined;
        message.gracePeriodMinutes = object.gracePeriodMinutes ?? 0;
        message.maxAmount =
            object.maxAmount !== undefined && object.maxAmount !== null
                ? exports.Money.fromPartial(object.maxAmount)
                : undefined;
        return message;
    },
};
function createBasePricingModel() {
    return {
        pricePerKwh: undefined,
        pricePerMinute: undefined,
        freemode: undefined,
        idleFeesAfterChargingStarts: undefined,
        idleFeesAfterChargingEnds: undefined,
        surcharges: [],
        membershipPricing: undefined,
    };
}
exports.PricingModel = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.pricePerKwh !== undefined) {
            exports.PricePerKWH.encode(message.pricePerKwh, writer.uint32(10).fork()).join();
        }
        if (message.pricePerMinute !== undefined) {
            exports.PricePerMinute.encode(message.pricePerMinute, writer.uint32(18).fork()).join();
        }
        if (message.freemode !== undefined) {
            exports.Freemode.encode(message.freemode, writer.uint32(26).fork()).join();
        }
        if (message.idleFeesAfterChargingStarts !== undefined) {
            exports.IdleFees.encode(message.idleFeesAfterChargingStarts, writer.uint32(34).fork()).join();
        }
        if (message.idleFeesAfterChargingEnds !== undefined) {
            exports.IdleFees.encode(message.idleFeesAfterChargingEnds, writer.uint32(42).fork()).join();
        }
        for (const v of message.surcharges) {
            exports.Surcharge.encode(v, writer.uint32(50).fork()).join();
        }
        if (message.membershipPricing !== undefined) {
            exports.MembershipPricing.encode(message.membershipPricing, writer.uint32(58).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePricingModel();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.pricePerKwh = exports.PricePerKWH.decode(reader, reader.uint32());
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.pricePerMinute = exports.PricePerMinute.decode(reader, reader.uint32());
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.freemode = exports.Freemode.decode(reader, reader.uint32());
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.idleFeesAfterChargingStarts = exports.IdleFees.decode(reader, reader.uint32());
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.idleFeesAfterChargingEnds = exports.IdleFees.decode(reader, reader.uint32());
                    continue;
                }
                case 6: {
                    if (tag !== 50) {
                        break;
                    }
                    message.surcharges.push(exports.Surcharge.decode(reader, reader.uint32()));
                    continue;
                }
                case 7: {
                    if (tag !== 58) {
                        break;
                    }
                    message.membershipPricing = exports.MembershipPricing.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            pricePerKwh: isSet(object.pricePerKwh)
                ? exports.PricePerKWH.fromJSON(object.pricePerKwh)
                : isSet(object.price_per_kwh)
                    ? exports.PricePerKWH.fromJSON(object.price_per_kwh)
                    : undefined,
            pricePerMinute: isSet(object.pricePerMinute)
                ? exports.PricePerMinute.fromJSON(object.pricePerMinute)
                : isSet(object.price_per_minute)
                    ? exports.PricePerMinute.fromJSON(object.price_per_minute)
                    : undefined,
            freemode: isSet(object.freemode)
                ? exports.Freemode.fromJSON(object.freemode)
                : undefined,
            idleFeesAfterChargingStarts: isSet(object.idleFeesAfterChargingStarts)
                ? exports.IdleFees.fromJSON(object.idleFeesAfterChargingStarts)
                : isSet(object.idle_fees_after_charging_starts)
                    ? exports.IdleFees.fromJSON(object.idle_fees_after_charging_starts)
                    : undefined,
            idleFeesAfterChargingEnds: isSet(object.idleFeesAfterChargingEnds)
                ? exports.IdleFees.fromJSON(object.idleFeesAfterChargingEnds)
                : isSet(object.idle_fees_after_charging_ends)
                    ? exports.IdleFees.fromJSON(object.idle_fees_after_charging_ends)
                    : undefined,
            surcharges: globalThis.Array.isArray(object?.surcharges)
                ? object.surcharges.map((e) => exports.Surcharge.fromJSON(e))
                : [],
            membershipPricing: isSet(object.membershipPricing)
                ? exports.MembershipPricing.fromJSON(object.membershipPricing)
                : isSet(object.membership_pricing)
                    ? exports.MembershipPricing.fromJSON(object.membership_pricing)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.pricePerKwh !== undefined) {
            obj.pricePerKwh = exports.PricePerKWH.toJSON(message.pricePerKwh);
        }
        if (message.pricePerMinute !== undefined) {
            obj.pricePerMinute = exports.PricePerMinute.toJSON(message.pricePerMinute);
        }
        if (message.freemode !== undefined) {
            obj.freemode = exports.Freemode.toJSON(message.freemode);
        }
        if (message.idleFeesAfterChargingStarts !== undefined) {
            obj.idleFeesAfterChargingStarts = exports.IdleFees.toJSON(message.idleFeesAfterChargingStarts);
        }
        if (message.idleFeesAfterChargingEnds !== undefined) {
            obj.idleFeesAfterChargingEnds = exports.IdleFees.toJSON(message.idleFeesAfterChargingEnds);
        }
        if (message.surcharges?.length) {
            obj.surcharges = message.surcharges.map((e) => exports.Surcharge.toJSON(e));
        }
        if (message.membershipPricing !== undefined) {
            obj.membershipPricing = exports.MembershipPricing.toJSON(message.membershipPricing);
        }
        return obj;
    },
    create(base) {
        return exports.PricingModel.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePricingModel();
        message.pricePerKwh =
            object.pricePerKwh !== undefined && object.pricePerKwh !== null
                ? exports.PricePerKWH.fromPartial(object.pricePerKwh)
                : undefined;
        message.pricePerMinute =
            object.pricePerMinute !== undefined && object.pricePerMinute !== null
                ? exports.PricePerMinute.fromPartial(object.pricePerMinute)
                : undefined;
        message.freemode =
            object.freemode !== undefined && object.freemode !== null
                ? exports.Freemode.fromPartial(object.freemode)
                : undefined;
        message.idleFeesAfterChargingStarts =
            object.idleFeesAfterChargingStarts !== undefined &&
                object.idleFeesAfterChargingStarts !== null
                ? exports.IdleFees.fromPartial(object.idleFeesAfterChargingStarts)
                : undefined;
        message.idleFeesAfterChargingEnds =
            object.idleFeesAfterChargingEnds !== undefined &&
                object.idleFeesAfterChargingEnds !== null
                ? exports.IdleFees.fromPartial(object.idleFeesAfterChargingEnds)
                : undefined;
        message.surcharges =
            object.surcharges?.map((e) => exports.Surcharge.fromPartial(e)) || [];
        message.membershipPricing =
            object.membershipPricing !== undefined &&
                object.membershipPricing !== null
                ? exports.MembershipPricing.fromPartial(object.membershipPricing)
                : undefined;
        return message;
    },
};
function createBaseMembershipPricing() {
    return { tierPricingModels: {}, defaultMembershipPricingModel: undefined };
}
exports.MembershipPricing = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        globalThis.Object.entries(message.tierPricingModels).forEach(([key, value]) => {
            exports.MembershipPricing_TierPricingModelsEntry.encode({ key: key, value }, writer.uint32(10).fork()).join();
        });
        if (message.defaultMembershipPricingModel !== undefined) {
            exports.PricingModel.encode(message.defaultMembershipPricingModel, writer.uint32(18).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMembershipPricing();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    const entry1 = exports.MembershipPricing_TierPricingModelsEntry.decode(reader, reader.uint32());
                    if (entry1.value !== undefined) {
                        message.tierPricingModels[entry1.key] = entry1.value;
                    }
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.defaultMembershipPricingModel = exports.PricingModel.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            tierPricingModels: isObject(object.tierPricingModels)
                ? globalThis.Object.entries(object.tierPricingModels).reduce((acc, [key, value]) => {
                    acc[key] = exports.PricingModel.fromJSON(value);
                    return acc;
                }, {})
                : isObject(object.tier_pricing_models)
                    ? globalThis.Object.entries(object.tier_pricing_models).reduce((acc, [key, value]) => {
                        acc[key] = exports.PricingModel.fromJSON(value);
                        return acc;
                    }, {})
                    : {},
            defaultMembershipPricingModel: isSet(object.defaultMembershipPricingModel)
                ? exports.PricingModel.fromJSON(object.defaultMembershipPricingModel)
                : isSet(object.default_membership_pricing_model)
                    ? exports.PricingModel.fromJSON(object.default_membership_pricing_model)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.tierPricingModels) {
            const entries = globalThis.Object.entries(message.tierPricingModels);
            if (entries.length > 0) {
                obj.tierPricingModels = {};
                entries.forEach(([k, v]) => {
                    obj.tierPricingModels[k] = exports.PricingModel.toJSON(v);
                });
            }
        }
        if (message.defaultMembershipPricingModel !== undefined) {
            obj.defaultMembershipPricingModel = exports.PricingModel.toJSON(message.defaultMembershipPricingModel);
        }
        return obj;
    },
    create(base) {
        return exports.MembershipPricing.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMembershipPricing();
        message.tierPricingModels = globalThis.Object.entries(object.tierPricingModels ?? {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = exports.PricingModel.fromPartial(value);
            }
            return acc;
        }, {});
        message.defaultMembershipPricingModel =
            object.defaultMembershipPricingModel !== undefined &&
                object.defaultMembershipPricingModel !== null
                ? exports.PricingModel.fromPartial(object.defaultMembershipPricingModel)
                : undefined;
        return message;
    },
};
function createBaseMembershipPricing_TierPricingModelsEntry() {
    return { key: "", value: undefined };
}
exports.MembershipPricing_TierPricingModelsEntry = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== undefined) {
            exports.PricingModel.encode(message.value, writer.uint32(18).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMembershipPricing_TierPricingModelsEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.value = exports.PricingModel.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: isSet(object.key) ? globalThis.String(object.key) : "",
            value: isSet(object.value)
                ? exports.PricingModel.fromJSON(object.value)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.key !== "") {
            obj.key = message.key;
        }
        if (message.value !== undefined) {
            obj.value = exports.PricingModel.toJSON(message.value);
        }
        return obj;
    },
    create(base) {
        return exports.MembershipPricing_TierPricingModelsEntry.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMembershipPricing_TierPricingModelsEntry();
        message.key = object.key ?? "";
        message.value =
            object.value !== undefined && object.value !== null
                ? exports.PricingModel.fromPartial(object.value)
                : undefined;
        return message;
    },
};
function createBaseFreeChargingSession() {
    return {
        nthSessionFree: 0,
        minSpendForCountedSession: undefined,
        minKwhForCountedSession: undefined,
        maxSpendOnFreeSession: undefined,
    };
}
exports.FreeChargingSession = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.nthSessionFree !== 0) {
            writer.uint32(8).uint32(message.nthSessionFree);
        }
        if (message.minSpendForCountedSession !== undefined) {
            exports.Money.encode(message.minSpendForCountedSession, writer.uint32(18).fork()).join();
        }
        if (message.minKwhForCountedSession !== undefined) {
            exports.Money.encode(message.minKwhForCountedSession, writer.uint32(26).fork()).join();
        }
        if (message.maxSpendOnFreeSession !== undefined) {
            exports.Money.encode(message.maxSpendOnFreeSession, writer.uint32(34).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFreeChargingSession();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.nthSessionFree = reader.uint32();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.minSpendForCountedSession = exports.Money.decode(reader, reader.uint32());
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.minKwhForCountedSession = exports.Money.decode(reader, reader.uint32());
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.maxSpendOnFreeSession = exports.Money.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            nthSessionFree: isSet(object.nthSessionFree)
                ? globalThis.Number(object.nthSessionFree)
                : isSet(object.nth_session_free)
                    ? globalThis.Number(object.nth_session_free)
                    : 0,
            minSpendForCountedSession: isSet(object.minSpendForCountedSession)
                ? exports.Money.fromJSON(object.minSpendForCountedSession)
                : isSet(object.min_spend_for_counted_session)
                    ? exports.Money.fromJSON(object.min_spend_for_counted_session)
                    : undefined,
            minKwhForCountedSession: isSet(object.minKwhForCountedSession)
                ? exports.Money.fromJSON(object.minKwhForCountedSession)
                : isSet(object.min_kwh_for_counted_session)
                    ? exports.Money.fromJSON(object.min_kwh_for_counted_session)
                    : undefined,
            maxSpendOnFreeSession: isSet(object.maxSpendOnFreeSession)
                ? exports.Money.fromJSON(object.maxSpendOnFreeSession)
                : isSet(object.max_spend_on_free_session)
                    ? exports.Money.fromJSON(object.max_spend_on_free_session)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.nthSessionFree !== 0) {
            obj.nthSessionFree = Math.round(message.nthSessionFree);
        }
        if (message.minSpendForCountedSession !== undefined) {
            obj.minSpendForCountedSession = exports.Money.toJSON(message.minSpendForCountedSession);
        }
        if (message.minKwhForCountedSession !== undefined) {
            obj.minKwhForCountedSession = exports.Money.toJSON(message.minKwhForCountedSession);
        }
        if (message.maxSpendOnFreeSession !== undefined) {
            obj.maxSpendOnFreeSession = exports.Money.toJSON(message.maxSpendOnFreeSession);
        }
        return obj;
    },
    create(base) {
        return exports.FreeChargingSession.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFreeChargingSession();
        message.nthSessionFree = object.nthSessionFree ?? 0;
        message.minSpendForCountedSession =
            object.minSpendForCountedSession !== undefined &&
                object.minSpendForCountedSession !== null
                ? exports.Money.fromPartial(object.minSpendForCountedSession)
                : undefined;
        message.minKwhForCountedSession =
            object.minKwhForCountedSession !== undefined &&
                object.minKwhForCountedSession !== null
                ? exports.Money.fromPartial(object.minKwhForCountedSession)
                : undefined;
        message.maxSpendOnFreeSession =
            object.maxSpendOnFreeSession !== undefined &&
                object.maxSpendOnFreeSession !== null
                ? exports.Money.fromPartial(object.maxSpendOnFreeSession)
                : undefined;
        return message;
    },
};
function createBaseDiscountedSession() {
    return { discountedSessionName: false, percentageDiscount: 0 };
}
exports.DiscountedSession = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.discountedSessionName !== false) {
            writer.uint32(8).bool(message.discountedSessionName);
        }
        if (message.percentageDiscount !== 0) {
            writer.uint32(25).double(message.percentageDiscount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDiscountedSession();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.discountedSessionName = reader.bool();
                    continue;
                }
                case 3: {
                    if (tag !== 25) {
                        break;
                    }
                    message.percentageDiscount = reader.double();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            discountedSessionName: isSet(object.discountedSessionName)
                ? globalThis.Boolean(object.discountedSessionName)
                : isSet(object.discounted_session_name)
                    ? globalThis.Boolean(object.discounted_session_name)
                    : false,
            percentageDiscount: isSet(object.percentageDiscount)
                ? globalThis.Number(object.percentageDiscount)
                : isSet(object.percentage_discount)
                    ? globalThis.Number(object.percentage_discount)
                    : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.discountedSessionName !== false) {
            obj.discountedSessionName = message.discountedSessionName;
        }
        if (message.percentageDiscount !== 0) {
            obj.percentageDiscount = message.percentageDiscount;
        }
        return obj;
    },
    create(base) {
        return exports.DiscountedSession.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDiscountedSession();
        message.discountedSessionName = object.discountedSessionName ?? false;
        message.percentageDiscount = object.percentageDiscount ?? 0;
        return message;
    },
};
function createBaseIncentiveModel() {
    return {
        freeChargingIncentiveEnabled: false,
        discountedChargingIncetiveEnabled: false,
        inStoreDiscountsEnabled: false,
        freeChargingSession: undefined,
        discountedSessions: [],
    };
}
exports.IncentiveModel = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.freeChargingIncentiveEnabled !== false) {
            writer.uint32(8).bool(message.freeChargingIncentiveEnabled);
        }
        if (message.discountedChargingIncetiveEnabled !== false) {
            writer.uint32(16).bool(message.discountedChargingIncetiveEnabled);
        }
        if (message.inStoreDiscountsEnabled !== false) {
            writer.uint32(24).bool(message.inStoreDiscountsEnabled);
        }
        if (message.freeChargingSession !== undefined) {
            exports.FreeChargingSession.encode(message.freeChargingSession, writer.uint32(34).fork()).join();
        }
        for (const v of message.discountedSessions) {
            exports.DiscountedSession.encode(v, writer.uint32(42).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseIncentiveModel();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.freeChargingIncentiveEnabled = reader.bool();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.discountedChargingIncetiveEnabled = reader.bool();
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.inStoreDiscountsEnabled = reader.bool();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.freeChargingSession = exports.FreeChargingSession.decode(reader, reader.uint32());
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.discountedSessions.push(exports.DiscountedSession.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            freeChargingIncentiveEnabled: isSet(object.freeChargingIncentiveEnabled)
                ? globalThis.Boolean(object.freeChargingIncentiveEnabled)
                : isSet(object.free_charging_incentive_enabled)
                    ? globalThis.Boolean(object.free_charging_incentive_enabled)
                    : false,
            discountedChargingIncetiveEnabled: isSet(object.discountedChargingIncetiveEnabled)
                ? globalThis.Boolean(object.discountedChargingIncetiveEnabled)
                : isSet(object.discounted_charging_incetive_enabled)
                    ? globalThis.Boolean(object.discounted_charging_incetive_enabled)
                    : false,
            inStoreDiscountsEnabled: isSet(object.inStoreDiscountsEnabled)
                ? globalThis.Boolean(object.inStoreDiscountsEnabled)
                : isSet(object.in_store_discounts_enabled)
                    ? globalThis.Boolean(object.in_store_discounts_enabled)
                    : false,
            freeChargingSession: isSet(object.freeChargingSession)
                ? exports.FreeChargingSession.fromJSON(object.freeChargingSession)
                : isSet(object.free_charging_session)
                    ? exports.FreeChargingSession.fromJSON(object.free_charging_session)
                    : undefined,
            discountedSessions: globalThis.Array.isArray(object?.discountedSessions)
                ? object.discountedSessions.map((e) => exports.DiscountedSession.fromJSON(e))
                : globalThis.Array.isArray(object?.discounted_sessions)
                    ? object.discounted_sessions.map((e) => exports.DiscountedSession.fromJSON(e))
                    : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.freeChargingIncentiveEnabled !== false) {
            obj.freeChargingIncentiveEnabled = message.freeChargingIncentiveEnabled;
        }
        if (message.discountedChargingIncetiveEnabled !== false) {
            obj.discountedChargingIncetiveEnabled =
                message.discountedChargingIncetiveEnabled;
        }
        if (message.inStoreDiscountsEnabled !== false) {
            obj.inStoreDiscountsEnabled = message.inStoreDiscountsEnabled;
        }
        if (message.freeChargingSession !== undefined) {
            obj.freeChargingSession = exports.FreeChargingSession.toJSON(message.freeChargingSession);
        }
        if (message.discountedSessions?.length) {
            obj.discountedSessions = message.discountedSessions.map((e) => exports.DiscountedSession.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.IncentiveModel.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseIncentiveModel();
        message.freeChargingIncentiveEnabled =
            object.freeChargingIncentiveEnabled ?? false;
        message.discountedChargingIncetiveEnabled =
            object.discountedChargingIncetiveEnabled ?? false;
        message.inStoreDiscountsEnabled = object.inStoreDiscountsEnabled ?? false;
        message.freeChargingSession =
            object.freeChargingSession !== undefined &&
                object.freeChargingSession !== null
                ? exports.FreeChargingSession.fromPartial(object.freeChargingSession)
                : undefined;
        message.discountedSessions =
            object.discountedSessions?.map((e) => exports.DiscountedSession.fromPartial(e)) ||
                [];
        return message;
    },
};
function createBaseCostcoOwner() {
    return {};
}
exports.CostcoOwner = {
    encode(_, writer = new wire_1.BinaryWriter()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCostcoOwner();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.CostcoOwner.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseCostcoOwner();
        return message;
    },
};
function createBasePaymentRestriction() {
    return {
        allowedCardNetworks: [],
        allowedBinRanges: [],
        allowAllDebitCards: false,
        allowAllCreditCards: false,
        costco: undefined,
    };
}
exports.PaymentRestriction = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        writer.uint32(10).fork();
        for (const v of message.allowedCardNetworks) {
            writer.int32(v);
        }
        writer.join();
        for (const v of message.allowedBinRanges) {
            writer.uint32(18).string(v);
        }
        if (message.allowAllDebitCards !== false) {
            writer.uint32(24).bool(message.allowAllDebitCards);
        }
        if (message.allowAllCreditCards !== false) {
            writer.uint32(32).bool(message.allowAllCreditCards);
        }
        if (message.costco !== undefined) {
            exports.CostcoOwner.encode(message.costco, writer.uint32(42).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePaymentRestriction();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag === 8) {
                        message.allowedCardNetworks.push(reader.int32());
                        continue;
                    }
                    if (tag === 10) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.allowedCardNetworks.push(reader.int32());
                        }
                        continue;
                    }
                    break;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.allowedBinRanges.push(reader.string());
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.allowAllDebitCards = reader.bool();
                    continue;
                }
                case 4: {
                    if (tag !== 32) {
                        break;
                    }
                    message.allowAllCreditCards = reader.bool();
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.costco = exports.CostcoOwner.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            allowedCardNetworks: globalThis.Array.isArray(object?.allowedCardNetworks)
                ? object.allowedCardNetworks.map((e) => cardNetworkFromJSON(e))
                : globalThis.Array.isArray(object?.allowed_card_networks)
                    ? object.allowed_card_networks.map((e) => cardNetworkFromJSON(e))
                    : [],
            allowedBinRanges: globalThis.Array.isArray(object?.allowedBinRanges)
                ? object.allowedBinRanges.map((e) => globalThis.String(e))
                : globalThis.Array.isArray(object?.allowed_bin_ranges)
                    ? object.allowed_bin_ranges.map((e) => globalThis.String(e))
                    : [],
            allowAllDebitCards: isSet(object.allowAllDebitCards)
                ? globalThis.Boolean(object.allowAllDebitCards)
                : isSet(object.allow_all_debit_cards)
                    ? globalThis.Boolean(object.allow_all_debit_cards)
                    : false,
            allowAllCreditCards: isSet(object.allowAllCreditCards)
                ? globalThis.Boolean(object.allowAllCreditCards)
                : isSet(object.allow_all_credit_cards)
                    ? globalThis.Boolean(object.allow_all_credit_cards)
                    : false,
            costco: isSet(object.costco)
                ? exports.CostcoOwner.fromJSON(object.costco)
                : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.allowedCardNetworks?.length) {
            obj.allowedCardNetworks = message.allowedCardNetworks.map((e) => cardNetworkToJSON(e));
        }
        if (message.allowedBinRanges?.length) {
            obj.allowedBinRanges = message.allowedBinRanges;
        }
        if (message.allowAllDebitCards !== false) {
            obj.allowAllDebitCards = message.allowAllDebitCards;
        }
        if (message.allowAllCreditCards !== false) {
            obj.allowAllCreditCards = message.allowAllCreditCards;
        }
        if (message.costco !== undefined) {
            obj.costco = exports.CostcoOwner.toJSON(message.costco);
        }
        return obj;
    },
    create(base) {
        return exports.PaymentRestriction.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePaymentRestriction();
        message.allowedCardNetworks =
            object.allowedCardNetworks?.map((e) => e) || [];
        message.allowedBinRanges = object.allowedBinRanges?.map((e) => e) || [];
        message.allowAllDebitCards = object.allowAllDebitCards ?? false;
        message.allowAllCreditCards = object.allowAllCreditCards ?? false;
        message.costco =
            object.costco !== undefined && object.costco !== null
                ? exports.CostcoOwner.fromPartial(object.costco)
                : undefined;
        return message;
    },
};
function createBaseBinData() {
    return {
        binValue: "",
        cardType: "",
        country: undefined,
        currency: undefined,
        debit: undefined,
    };
}
exports.BinData = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.binValue !== "") {
            writer.uint32(10).string(message.binValue);
        }
        if (message.cardType !== "") {
            writer.uint32(18).string(message.cardType);
        }
        if (message.country !== undefined) {
            writer.uint32(26).string(message.country);
        }
        if (message.currency !== undefined) {
            writer.uint32(34).string(message.currency);
        }
        if (message.debit !== undefined) {
            writer.uint32(40).bool(message.debit);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseBinData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.binValue = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.cardType = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.country = reader.string();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.currency = reader.string();
                    continue;
                }
                case 5: {
                    if (tag !== 40) {
                        break;
                    }
                    message.debit = reader.bool();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            binValue: isSet(object.binValue)
                ? globalThis.String(object.binValue)
                : isSet(object.bin_value)
                    ? globalThis.String(object.bin_value)
                    : "",
            cardType: isSet(object.cardType)
                ? globalThis.String(object.cardType)
                : isSet(object.card_type)
                    ? globalThis.String(object.card_type)
                    : "",
            country: isSet(object.country)
                ? globalThis.String(object.country)
                : undefined,
            currency: isSet(object.currency)
                ? globalThis.String(object.currency)
                : undefined,
            debit: isSet(object.debit) ? globalThis.Boolean(object.debit) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.binValue !== "") {
            obj.binValue = message.binValue;
        }
        if (message.cardType !== "") {
            obj.cardType = message.cardType;
        }
        if (message.country !== undefined) {
            obj.country = message.country;
        }
        if (message.currency !== undefined) {
            obj.currency = message.currency;
        }
        if (message.debit !== undefined) {
            obj.debit = message.debit;
        }
        return obj;
    },
    create(base) {
        return exports.BinData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBinData();
        message.binValue = object.binValue ?? "";
        message.cardType = object.cardType ?? "";
        message.country = object.country ?? undefined;
        message.currency = object.currency ?? undefined;
        message.debit = object.debit ?? undefined;
        return message;
    },
};
function toTimestamp(date) {
    const seconds = Math.trunc(date.getTime() / 1000);
    const nanos = (date.getTime() % 1000) * 1000000;
    return { seconds, nanos };
}
function fromTimestamp(t) {
    let millis = (t.seconds || 0) * 1000;
    millis += (t.nanos || 0) / 1000000;
    return new globalThis.Date(millis);
}
function fromJsonTimestamp(o) {
    if (o instanceof globalThis.Date) {
        return o;
    }
    else if (typeof o === "string") {
        return new globalThis.Date(o);
    }
    else {
        return fromTimestamp(timestamp_1.Timestamp.fromJSON(o));
    }
}
function isObject(value) {
    return typeof value === "object" && value !== null;
}
function isSet(value) {
    return value !== null && value !== undefined;
}
